import PropTypes from 'prop-types';
import { useMemo, useState } from 'react';
import { DataContext } from '../contexts/DataContext';

const DataProvider = props => {
  const [currentFlowIdentifier, setCurrentFlowIdentifier] = useState('');
  const [selectedLocationIndex, setSelectedLocationIndex] = useState();
  const [selectedAppointmentDate, setSelectedAppointmentDate] = useState();
  const [timeInfo, setTimeInfo] = useState();

  const contextValue = useMemo(
    () => ({
      currentFlowIdentifier,
      setCurrentFlowIdentifier,
      selectedLocationIndex,
      setSelectedLocationIndex,
      selectedAppointmentDate,
      setSelectedAppointmentDate,
      timeInfo,
      setTimeInfo
    }),
    [currentFlowIdentifier, selectedLocationIndex, selectedAppointmentDate, timeInfo]
  );

  return <DataContext.Provider value={contextValue}>{props.children}</DataContext.Provider>;
};

DataProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default DataProvider;
